export default "__VITE_ASSET__XX02i3G$__"